import type React from "react";
import "./RenderLinksWithTooltips.css";

type Props = {
    children: React.ReactNode;
    referenceQuerySelector?: string | undefined;
};

function RenderLinksWithTooltips({ children, referenceQuerySelector }: Props) {
    const handlePositioningLinkTooltips = (event: React.MouseEvent<HTMLDivElement>) => {
        if (!referenceQuerySelector) return;
        const referencePosition = document
            .querySelector(referenceQuerySelector)
            ?.getBoundingClientRect();

        if (!referencePosition) {
            console.error("Could not dynamically position the link tooltips");
            return;
        }
        event.currentTarget.querySelectorAll("a").forEach((link) => {
            const linkPosition = link.getBoundingClientRect();

            const isOnLeft =
                linkPosition.x <= referencePosition.x + referencePosition.width / 3;
            const isOnRight =
                linkPosition.x >=
                referencePosition.x + referencePosition.width * (2 / 3);

            if (isOnLeft) link.classList.add("dynamic-position-left");
            else link.classList.remove("dynamic-position-left");

            if (isOnRight) link.classList.add("dynamic-position-right");
            else link.classList.remove("dynamic-position-right");
        });
    };

    return (
        <div
            className="render-links-with-tooltips"
            onMouseEnter={handlePositioningLinkTooltips}
        >
            {children}
        </div>
    );
}

export default RenderLinksWithTooltips;
